export default __webpack_public_path__ + "static/media/icon-trash.cadc8a7e.svg";